import React from 'react'

import { useTranslation } from '@mc/i18n'

import { Bullets } from './Bullets'

export const ActiveParticipationSection = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <section className='d-flex justify-content-center mc-mt-12 mc-color-dark'>
      <div>
        <h2 className='mc-text-h1 mc-mb-9 mc-text--center'>
          {t('sessions.activeParticipationSection.header')}
        </h2>

        <div className='d-none d-sm-block'>
          <Bullets gteSM />
        </div>
        <div className='d-block d-sm-none'>
          <Bullets gteSM={false} />
        </div>
      </div>
    </section>
  )
}
